import { useParams } from "react-router-dom";

import CattleForm from "@/features/Animals/cattle-form.tsx";

export function RecipientForm() {
  const { id } = useParams<{ id: string }>();

  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 z-10">
      <div className="mx-auto max-w-5xl ">
        <div className="w-full mb-8 text-center">
          <div className="px-2 lg:w-full lg:flex items-center justify-between sm:full sm:flex sm:flex-col sm:items-center ">
            {/* <img alt="Logo" className="h-10 lg:h-16 z-20 " src={logo} /> */}

            {/* <h1 className="text-xl text-[#008c8fff] items-center font-medium tracking-tight md:text-3xl"> */}
            {/*   Sila Green Cattle Management System */}
            {/* </h1> */}
          </div>
          <p className="mt-2 text-[#015354ff] text-center">
            Advanced data collection for comprehensive cattle management
          </p>
        </div>
        <CattleForm id={id} />
      </div>
    </main>
  );
}
